import { useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function AdminChats() {
  const [token, setToken] = useState("");
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const load = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await fetch(`${API}/api/admin/chats?token=${encodeURIComponent(token)}`);
      if (!res.ok) throw new Error(res.status === 401 ? "Wrong access token" : "Failed to load");
      setData(await res.json());
    } catch (err) {
      setError(err.message);
      setData(null);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FBF6EC] p-5 font-mukta text-[#3B221B] md:p-8">
      <h1 className="font-eczar text-2xl font-bold">Chat visitors</h1>
      <p className="mt-1 text-sm text-[#6B5044]">Every conversation from the site assistant. Sessions that shared a phone/email are flagged.</p>

      <form onSubmit={load} className="mt-4 flex max-w-md gap-2">
        <input type="password" value={token} onChange={(e) => setToken(e.target.value)} data-testid="admin-token-input"
          placeholder="Access token" className="flex-1 rounded-lg border border-[#A8722A]/30 bg-white px-3 py-2 text-sm outline-none focus:border-[#A8722A]" />
        <button type="submit" data-testid="admin-load-btn" className="rounded-lg bg-[#B23A2B] px-5 py-2 text-sm font-semibold text-white hover:bg-[#9a2f22]">
          {loading ? "Loading…" : "View"}
        </button>
      </form>
      {error && <p className="mt-3 text-sm font-semibold text-[#B23A2B]" data-testid="admin-error">{error}</p>}

      {data && (
        <div className="mt-6">
          <p className="text-sm font-semibold" data-testid="admin-summary">
            {data.count} sessions · {data.with_contact} shared contact details
          </p>
          <div className="mt-4 space-y-4">
            {data.sessions.map((s) => (
              <div key={s.session_id} className={`rounded-[14px] border p-4 ${s.has_contact ? "border-[#3E6B4F]/50 bg-[#3E6B4F]/[0.06]" : "border-[#A8722A]/25 bg-[#FFFDF8]"}`} data-testid="admin-session">
                <div className="flex flex-wrap items-center justify-between gap-2 text-xs text-[#6B5044]">
                  <span>{new Date(s.last_at).toLocaleString()} · {s.page || "/"} · {s.message_count} msgs</span>
                  {s.has_contact && <span className="rounded-full bg-[#3E6B4F] px-2 py-0.5 font-semibold text-white">Contact: {(s.contacts || []).join(", ")}</span>}
                </div>
                <div className="mt-3 space-y-2">
                  {s.messages.map((m, i) => (
                    <div key={i} className={`text-sm ${m.role === "user" ? "text-[#3B221B]" : "text-[#6B5044]"}`}>
                      <span className="font-semibold">{m.role === "user" ? "Visitor" : "Sahayaka"}:</span> {m.content}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
